import { useLocalStorage } from '@uidotdev/usehooks'

export const useExpandedState = (initialState: boolean, storageKey: string) => {
  const [isExpanded, setIsExpanded] = useLocalStorage(storageKey, initialState)
  const toggleExpanded = () => setIsExpanded((prev) => !prev)
  return { isExpanded, toggleExpanded }
}
